export const DATE_FORMAT = "MM/DD/YYYY";

export const DROPDOWN = {
  LABEL: "Date",
  PLACEHOLDER: "Select Date",
  WIDTH: "100%",
};

export const TOTAL_SCORE_LABEL = "Total Score: ";

export const CHART = {
  ID: "altchartdiv",
  HEIGHT: 400,
  PADDING: 20,
  VALUE_AXIS_MIN: 0,
  VALUE_AXIS_MAX: 10,
  LABEL_FONT_SIZE: 12,
};
